<template>
  <div>
    <v-layout wrap>
      <v-flex v-if="chosenItemsList.length === 0" xs8 class="red--text">
        業種分類を一つ以上選択してください。
      </v-flex>
      <v-flex xs12>
        <AppThreeColumnsSelector
          :broad-category-list="broadCategoryList"
          :sub-category-list="subCategoryList"
          :added-id-and-name-list="chosenItemsList"
          :use-search="true"
          @setIds="onChangeSelectedItemsList"
          @setSecondLeftItems="setSecondLeftItems"
          @search="filterItems"
          :broad-category-label="`大分類`"
          :sub-category-label="`中文類`"
          :right-label="`対象業種`"
          :item-name="`地域`"
        >
          <slot />
        </AppThreeColumnsSelector>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { MasterRepository } from '@/models/Master/MasterRepository'

export default {
  name: 'AppIndustrySelector',
  props: {
    chosenItemsList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      largeClassificationList: [],
      smallClassificationList: [],
      subCategoryList: [],
    }
  },
  computed: {
    broadCategoryList() {
      return this.largeClassificationList.map(item => this.makeItem(item))
    },
  },
  async created() {
    await this.fetchLargeClassificationList()
  },
  methods: {
    async fetchLargeClassificationList() {
      this.largeClassificationList = await MasterRepository.fetchLargeClassificationList()
      this.largeClassificationList.sort((a, b) => a.id - b.id)
    },
    makeItem(item) {
      return {
        id: item.sectorCode,
        name: item.name,
        selected: false,
        chosen: false,
      }
    },
    makeSubItem(item, parentName, parentId) {
      return {
        parentId: parentId,
        id: item.id,
        parentName: parentName,
        name: item.name,
        selected: false,
      }
    },
    async setSecondLeftItems(parentId, parentName) {
      this.smallClassificationList = await MasterRepository.fetchSmallClassificationList(
        {
          sectorCode: parentId,
        },
      )
      this.subCategoryList = this.smallClassificationList.map(item =>
        this.makeSubItem(item, parentName, parentId),
      )
    },
    onChangeSelectedItemsList(items) {
      this.$emit('onChangeSelectedItemsList', items)
    },
    filterItems(keyword) {
      this.subCategoryList = this.subCategoryList.filter(
        item => item.name.indexOf(keyword) !== -1,
      )
    },
  },
}
</script>
